// Catálogo Kbellos — navegación AJAX + interacciones de UI (delegadas)
(() => {
  const toast = document.querySelector('.toast');

  const showToast = (message) => {
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('is-visible');
    clearTimeout(showToast.timer);
    showToast.timer = setTimeout(() => toast.classList.remove('is-visible'), 2800);
  };

  // --- Navegación asíncrona: colecciones, filtros, orden y paginación ---
  const catalogRoot = () => document.querySelector('[data-catalog-root]');

  async function ajaxGo(url, push = true) {
    const root = catalogRoot();
    if (!root) { window.location.href = url; return; }
    root.classList.add('is-loading');
    try {
      const res = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (!res.ok) throw new Error('fetch-failed');
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const fresh = doc.querySelector('[data-catalog-root]');
      if (!fresh) throw new Error('no-catalog-root');
      root.replaceWith(fresh);
      if (push) history.pushState({}, '', url);
      catalogRoot()?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      fixAvailabilityCounts();
      initMobilePaging();
      initFilterFab();
    } catch {
      window.location.href = url;
    }
  }

  window.addEventListener('popstate', () => ajaxGo(window.location.href, false));

  // --- Paginación móvil: 8 productos visibles + botón "Ver más" ---
  const initMobilePaging = () => {
    const grid = document.querySelector('.catalog-grid');
    if (!grid) return;
    const isMobile = window.matchMedia('(max-width:700px)').matches;
    const items = [...grid.querySelectorAll('.catalog-product')];
    items.forEach((item, i) => item.classList.toggle('is-hidden', isMobile && i >= 8));
    let btn = document.querySelector('.catalog-more');
    if (isMobile && items.length > 8) {
      if (!btn) {
        btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'catalog-more';
        btn.textContent = 'Ver más productos';
        grid.insertAdjacentElement('afterend', btn);
      }
      const update = () => { btn.hidden = !grid.querySelector('.catalog-product.is-hidden'); };
      update();
      btn.onclick = () => {
        [...grid.querySelectorAll('.catalog-product.is-hidden')].slice(0, 8).forEach((el) => el.classList.remove('is-hidden'));
        update();
      };
    } else if (btn) { btn.hidden = true; }
  };
  initMobilePaging();
  window.addEventListener('resize', initMobilePaging);

  // --- Botón flotante de filtros: fade out cuando la grilla sale de pantalla ---
  let fabObserver;
  const initFilterFab = () => {
    const toggle = document.querySelector('.filter-toggle');
    const grid = document.querySelector('.catalog-grid');
    if (!toggle || !grid || !('IntersectionObserver' in window)) return;
    fabObserver?.disconnect();
    fabObserver = new IntersectionObserver(([entry]) => {
      toggle.classList.toggle('is-hidden', !entry.isIntersecting);
    }, { rootMargin: '-8px 0px 0px 0px' });
    fabObserver.observe(grid);
  };
  initFilterFab();

  // --- Conteos de disponibilidad reales ---
  // El índice de Search & Discovery puede quedar desfasado tras migraciones de
  // inventario masivas. Recalculamos desde products.json (disponibilidad en vivo).
  async function fixAvailabilityCounts() {
    const inputs = document.querySelectorAll('#filter-panel input[name="filter.v.availability"]');
    if (!inputs.length) return;
    const path = window.location.pathname;
    if (!path.includes('/collections/')) return;
    if (window.location.search.includes('filter.')) return;
    try {
      let inStock = 0;
      let total = 0;
      for (let page = 1; ; page += 1) {
        const res = await fetch(`${path}/products.json?limit=250&page=${page}`);
        if (!res.ok) return;
        const list = (await res.json()).products || [];
        list.forEach((p) => { if (p.available || p.variants?.some((v) => v.available)) inStock += 1; });
        total += list.length;
        if (list.length < 250) break;
      }
      inputs.forEach((input) => {
        const count = input.value === '1' ? inStock : total - inStock;
        const label = input.closest('label');
        const small = label?.querySelector('small');
        if (small) small.textContent = `(${count})`;
        if (!input.checked) {
          input.disabled = count === 0;
          label?.classList.toggle('is-disabled', count === 0);
        }
      });
    } catch { /* si falla quedan los conteos nativos de Shopify */ }
  }

  fixAvailabilityCounts();

  const buildFormUrl = (form) => {
    const qs = new URLSearchParams();
    for (const [key, value] of new FormData(form)) {
      if (value !== '') qs.append(key, value);
    }
    const query = qs.toString();
    return form.action + (query ? `?${query}` : '');
  };

  // --- Dropdown "Ordenar por" personalizado ---
  const closeSortMenus = () => {
    document.querySelectorAll('.sort-menu').forEach((m) => { m.hidden = true; });
    document.querySelectorAll('.sort-toggle').forEach((t) => t.setAttribute('aria-expanded', 'false'));
  };

  document.addEventListener('click', (event) => {
    const sortToggle = event.target.closest('.sort-toggle');
    if (sortToggle) {
      const dd = sortToggle.closest('.sort-dropdown');
      const menu = dd?.querySelector('.sort-menu');
      const willOpen = menu?.hidden;
      closeSortMenus();
      if (menu && willOpen) { menu.hidden = false; sortToggle.setAttribute('aria-expanded', 'true'); }
      return;
    }
    const opt = event.target.closest('.sort-option');
    if (opt) {
      const dd = opt.closest('.sort-dropdown');
      const select = dd?.querySelector('select#sort-products');
      const label = dd?.querySelector('.sort-toggle-label');
      if (label) label.textContent = opt.textContent.trim();
      dd?.querySelectorAll('.sort-option').forEach((o) => {
        const active = o === opt;
        o.classList.toggle('is-active', active);
        o.setAttribute('aria-selected', String(active));
      });
      closeSortMenus();
      if (select) { select.value = opt.dataset.sortValue; select.dispatchEvent(new Event('change', { bubbles: true })); }
      return;
    }
    // Click fuera del buscador del sidebar → cierra el dropdown
    if (!event.target.closest('.sidebar-search')) hideSuggests();
    // Click fuera del sort dropdown → cierra
    if (!event.target.closest('.sort-dropdown')) closeSortMenus();

    // "Ver todos los resultados" del dropdown → búsqueda AJAX
    const viewAll = event.target.closest('.sidebar-suggest-all');
    if (viewAll && catalogRoot()) {
      event.preventDefault();
      ajaxGo(viewAll.href);
      return;
    }

    // Links de categorías, limpiar filtros y paginación → navegación AJAX
    const navLink = event.target.closest('.catalog-sidebar a.check-option, .clear-filters, .pagination a');
    if (navLink && catalogRoot()) {
      event.preventDefault();
      document.querySelector('.catalog-sidebar')?.classList.remove('is-open');
      document.body.classList.remove('filter-open');
      ajaxGo(navLink.href);
      return;
    }

    const wish = event.target.closest('.wishlist');
    if (wish) {
      wish.classList.toggle('is-active');
      wish.setAttribute('aria-label', wish.classList.contains('is-active') ? 'Quitar de favoritos' : 'Añadir a favoritos');
      return;
    }

    const add = event.target.closest('.catalog-add');
    if (add && !add.disabled) showToast('Producto agregado al carrito.');

    const filterClose = event.target.closest('.filter-close, .filter-backdrop, .filter-apply');
    if (filterClose) {
      document.querySelector('.catalog-sidebar')?.classList.remove('is-open');
      document.querySelector('.filter-toggle')?.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('filter-open');
      return;
    }

    const toggle = event.target.closest('.filter-toggle');
    if (toggle) {
      const sidebar = document.querySelector('.catalog-sidebar');
      const open = sidebar?.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(open));
      document.body.classList.toggle('filter-open', Boolean(open));
      return;
    }

    const catToggle = event.target.closest('.cat-toggle');
    if (catToggle) {
      const list = catToggle.parentElement?.querySelector('.cat-list');
      const expanded = list?.classList.toggle('is-expanded');
      catToggle.setAttribute('aria-expanded', String(expanded));
      catToggle.innerHTML = expanded
        ? 'Ver menos <span class="hgi-stroke hgi-chevron-down" aria-hidden="true"></span>'
        : 'Ver más <span class="hgi-stroke hgi-chevron-down" aria-hidden="true"></span>';
      return;
    }

    const collapse = event.target.closest('.filter-collapse');
    if (collapse) {
      const group = collapse.closest('.filter-group');
      const collapsed = group?.classList.toggle('is-collapsed');
      collapse.setAttribute('aria-label', collapsed ? 'Expandir filtro' : 'Contraer filtro');
      group?.querySelectorAll('label,a.check-option,.cat-list,.cat-toggle,.price-slider,.price-track,.price-labels,.price-inputs').forEach((el) => { el.hidden = collapsed; });
    }
  });

  document.addEventListener('submit', (event) => {
    if (event.target.id === 'filter-panel' || event.target.matches('[data-sidebar-search]')) {
      event.preventDefault();
      ajaxGo(buildFormUrl(event.target));
    }
  });

  document.addEventListener('change', (event) => {
    const el = event.target;
    if (el.id === 'sort-products' || el.closest('#filter-panel')?.contains(el)) {
      const form = document.querySelector('#filter-panel');
      if (form) { event.preventDefault(); ajaxGo(buildFormUrl(form)); }
    }
  });

  // --- Buscador del sidebar con dropdown de sugerencias ---
  const moneyCLP = (value) => new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP', maximumFractionDigits: 0 }).format(Number(value) || 0);
  const searchRoot = window.Shopify?.routes?.root || '/';
  let suggestTimer;

  const suggestPanelOf = (form) => form?.querySelector('.sidebar-suggest');

  function hideSuggests(except) {
    document.querySelectorAll('.sidebar-suggest').forEach((p) => { if (p !== except) p.hidden = true; });
  }

  async function fetchSuggestions(form) {
    const panel = suggestPanelOf(form);
    const input = form.querySelector('input[name="q"]');
    const list = panel?.querySelector('.sidebar-suggest-list');
    const viewAll = panel?.querySelector('.sidebar-suggest-all');
    if (!panel || !list || !input) return;
    const query = input.value.trim();
    if (viewAll) viewAll.href = `${searchRoot}search?q=${encodeURIComponent(query)}`;
    if (!query) { panel.hidden = true; return; }
    try {
      const res = await fetch(`${searchRoot}search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=hide`);
      if (!res.ok) throw new Error('suggest-failed');
      const products = (await res.json()).resources?.results?.products || [];
      if (!panel.isConnected) return;
      list.innerHTML = products.length
        ? products.map((p) => {
          const compare = Number(p.compare_at_price) > Number(p.price) ? `<del>${moneyCLP(p.compare_at_price)}</del>` : '';
          return `<a class="suggest-item" href="${p.url}">${p.featured_image?.url ? `<img src="${p.featured_image.url}" alt="" loading="lazy">` : ''}<div class="suggest-item-info"><p>${p.title}</p><span>${moneyCLP(p.price)}${compare}</span></div></a>`;
        }).join('')
        : `<p class="suggest-empty">Sin resultados para «${query}»</p>`;
      panel.hidden = false;
    } catch {
      if (panel.isConnected) { list.innerHTML = `<p class="suggest-empty">No se pudo buscar ahora</p>`; panel.hidden = false; }
    }
  }

  document.addEventListener('focusin', (event) => {
    const input = event.target.closest?.('.sidebar-search input[name="q"]');
    if (!input) return;
    const form = input.closest('form');
    hideSuggests(suggestPanelOf(form));
    fetchSuggestions(form);
  });

  document.addEventListener('input', (event) => {
    const input = event.target.closest?.('.sidebar-search input[name="q"]');
    if (!input) return;
    const form = input.closest('form');
    window.clearTimeout(suggestTimer);
    suggestTimer = window.setTimeout(() => fetchSuggestions(form), 220);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') { hideSuggests(); closeSortMenus(); }
  });

  document.addEventListener('submit', (event) => {
    if (event.target.matches('[data-sidebar-search]')) hideSuggests();
  }, true);

  // --- Slider de precio: sincroniza deslizadores, inputs visibles, params ocultos y relleno ---
  const fmtCLP = (n) => new Intl.NumberFormat('es-CL', { maximumFractionDigits: 0 }).format(n);
  const parseCLP = (s) => { const n = parseInt(String(s).replace(/[^\d]/g, ''), 10); return Number.isNaN(n) ? null : n; };

  function syncPriceFilter(el) {
    const wrap = el.closest('.price-filter');
    if (!wrap) return;
    const sMin = wrap.querySelector('.price-slider-min');
    const sMax = wrap.querySelector('.price-slider-max');
    const iMin = wrap.querySelector('.price-input-min');
    const iMax = wrap.querySelector('.price-input-max');
    const hMin = wrap.querySelector('.price-param-min');
    const hMax = wrap.querySelector('.price-param-max');
    const fill = wrap.querySelector('.price-range-fill');
    if (!sMin || !sMax) return;
    const max = parseFloat(sMax.max) || 0;
    if (!max) return;
    let lo, hi;
    if (el === sMin || el === sMax) {
      lo = +sMin.value; hi = +sMax.value;
      if (lo > hi) { if (el === sMin) { lo = hi; sMin.value = lo; } else { hi = lo; sMax.value = hi; } }
    } else {
      lo = parseCLP(iMin?.value) ?? 0;
      hi = parseCLP(iMax?.value) ?? max;
      if (lo > hi) [lo, hi] = [hi, lo];
      sMin.value = lo; sMax.value = hi;
    }
    const effHi = Math.min(hi, max);
    if (iMin && (el === sMin || el === sMax)) iMin.value = lo > 0 ? fmtCLP(lo) : '';
    if (iMax && (el === sMin || el === sMax)) iMax.value = effHi < max ? fmtCLP(effHi) : '';
    if (hMin) hMin.value = lo > 0 ? lo : '';
    if (hMax) hMax.value = effHi < max ? effHi : '';
    if (fill) { fill.style.left = `${(lo / max) * 100}%`; fill.style.right = `${100 - (effHi / max) * 100}%`; }
  }

  document.addEventListener('input', (event) => {
    if (event.target.closest?.('.price-filter')) syncPriceFilter(event.target);
  });
})();
